import React from "react";
import moment from "moment";
import { BottomModal, Card, FlexColumn } from "../../Common/styles.common";
import BreakpointComponent from "components/core/Common/BreakpointCompnent";
import { DesktopPageTabsBar, MobilePageTabsBar } from "components/shared/PageTabs/PageTabs";

export const DDPoPageTabs = ({ pageConfig, activePage, onChange }) => {
  const Desktop = () => (
    <DesktopPageTabsBar tabs={pageConfig} activeKey={activePage} onChange={onChange} />
  );
  const Mobile = () => (
    <div style={{ background: "#ffffff", width: "100%" }}>
      <MobilePageTabsBar tabs={pageConfig} activeKey={activePage} onChange={onChange} />
    </div>
  );
  return <BreakpointComponent DesktopView={Desktop} MobileView={Mobile} />;
};

export const DDPoPaymentModal = ({ payment, onClose }) => (
  <BottomModal visible={Boolean(payment)} onClose={onClose} showCloseIcon>
    <div className="fs-18 fw-700 mt-4 mb-2 ml-4">Payment details</div>
    {payment && (
      <Card className="mt-2 mb-2 mx-4 my-4">
        <div className="d-flex align-items-center ml-4">
          <FlexColumn className="ml-2">
            <span className="fs-15 fw-600 mb-1 sushi-gray-dark">{payment.payment_method} payment</span>
            <span className="fs-13 fw-400 mb-1 medium-dark-gray">UTR no: {payment.transaction_info}</span>
            <span className="fs-13 fw-400 medium-dark-gray">
              {moment(new Date(payment.payment_date)).format("DD MMM, YYYY").toString()}
            </span>
          </FlexColumn>
        </div>
      </Card>
    )}
  </BottomModal>
);
